/* The Alt Art Co - scroll story. 4 acts over the pinned section:
   01 card alone (big)
   02 eight panels fly in around it to make the full scene
   03 the scene whooshes off, an empty binder page slides in, then everything slots in pocket by pocket in binder
      reading order (left to right, top to bottom; the card takes its own pocket in turn)
   ...and it ends there, on the filled page (the old 04 framed-print act was removed). */
(() => {
  const story = document.querySelector('[data-aac-story]');
  if (!story || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const acts = story.querySelectorAll('.aac-story__act'), num = story.querySelector('[data-aac-story-num]');
  const slots = [...story.querySelectorAll('.aac-story__slot')];
  const page = story.querySelector('.aac-story__page'), sheet = story.querySelector('.aac-story__sheet');
  const clamp = (v) => Math.max(0, Math.min(1, v));
  const ease = (t) => 1 - Math.pow(1 - t, 3);
  const io = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const idx = (s) => +s.style.getPropertyValue('--i');
  const from = slots.map((s) => {
    const i = idx(s), c = (i % 3) - 1, r = Math.floor(i / 3) - 1;
    return [c * 170 + (Math.random() - 0.5) * 50, r * 170 + (Math.random() - 0.5) * 50, (Math.random() - 0.5) * 36];
  });
  // timeline (fractions of the pinned scroll)
  const WHOOSH = [0.45, 0.05], SHEET_IN = [0.5, 0.06], SLOT0 = 0.565, SLOT_GAP = 0.02, SLOT_LEN = 0.05;
  const END = 0.9;   // the timeline finishes (page full + sticker) at 0.815: compress so the last bit of scroll holds the finished page
  // keep the pinned area below the sticky header
  const hdr = document.querySelector('header-component, [id*="__header_section"]');
  const setHdr = () => story.style.setProperty('--aac-hdr', (hdr ? Math.round(hdr.getBoundingClientRect().height) : 0) + 'px');
  setHdr(); addEventListener('resize', setHdr);
  let last = -1;

  function frame() {
    const r = story.getBoundingClientRect(), total = story.offsetHeight - innerHeight;
    const raw = clamp(-r.top / total), p = raw * END;
    if (Math.abs(p - last) < 0.0004) return;
    last = p;
    story.style.setProperty('--p', raw.toFixed(4));
    const act = Math.min(acts.length - 1, Math.floor(p * 4));
    acts.forEach((a, i) => a.classList.toggle('is-on', i === act));
    num.textContent = String(act + 1).padStart(2, '0');

    const fly = clamp((p - 0.14) / 0.2);
    const cardBig = 1 - ease(clamp((p - 0.12) / 0.14));
    // 00 intro: your card sits in a binder page among other pulls; the others drop away and it lifts out of its pocket
    const leave = ease(clamp((p - 0.015) / 0.06)), lift = io(clamp((p - 0.03) / 0.06));
    story.style.setProperty('--leave', leave.toFixed(3));
    const whoosh = ease(clamp((p - WHOOSH[0]) / WHOOSH[1]));
    const sheetIn = ease(clamp((p - SHEET_IN[0]) / SHEET_IN[1]));
    story.style.setProperty('--sheet', sheetIn.toFixed(3));

    slots.forEach((s, k) => {
      const i = idx(s), isCard = i === 4;
      let tx = 0, ty = 0, rot = 0, sc = 1, op = 1, inPocket = false;
      if (whoosh < 1) {
        // acts 1-2: assemble the scene
        if (isCard) { sc = 1 + cardBig * 0.85 * lift; rot = -3 * lift * cardBig; }
        else { const tt = ease(clamp(fly * 1.5 - k * 0.07)); const [x, y, ro] = from[k];
          tx = (1 - tt) * x; ty = (1 - tt) * y; rot = (1 - tt) * ro; sc = 0.85 + tt * 0.15; op = tt; }
        // whoosh: the whole scene sweeps off to the right
        tx += whoosh * (220 + (i % 3) * 40); ty += -whoosh * (30 + Math.floor(i / 3) * 10); rot += whoosh * 22; op *= 1 - whoosh;
      } else {
        // act 3: each pocket in turn, binder reading order (i = 0..8, card at 4)
        const t = clamp((p - (SLOT0 + i * SLOT_GAP)) / SLOT_LEN);
        const enter = ease(clamp(t / 0.55)), drop = io(clamp((t - 0.55) / 0.45));
        tx = (1 - enter) * 160; ty = (1 - enter) * -50 - 32 * (1 - drop); rot = (1 - enter) * 14;
        op = t > 0 ? 1 : 0; inPocket = t >= 1;
      }
      s.style.transform = `translate(${tx}%, ${ty}%) rotate(${rot}deg) scale(${sc})`;
      s.style.opacity = op;
      s.style.zIndex = inPocket ? 2 : (isCard && whoosh < 1 ? 6 : 4);
      s.classList.toggle('is-in', inPocket);
    });

    // binder page slides in from the left and stays: the story ends on the finished page
    sheet.style.transform = `translateX(${(1 - sheetIn) * -130}%) rotate(${(1 - sheetIn) * -8}deg)`;
    sheet.style.opacity = sheetIn;
    page.style.transform = 'none';
    page.style.opacity = 1;
    const done = ease(clamp((p - (SLOT0 + 8 * SLOT_GAP + SLOT_LEN)) / 0.04));
    story.style.setProperty('--sticker', done.toFixed(3));
  }
  // only run while the story is on screen
  let on = false, raf = 0;
  const loop = () => { frame(); raf = on ? requestAnimationFrame(loop) : 0; };
  new IntersectionObserver(([e]) => { on = e.isIntersecting; if (on && !raf) raf = requestAnimationFrame(loop); }, { rootMargin: '200px 0px' }).observe(story);
  frame();
})();
